<img
    aria-hidden="true"
    [ngSrc]="'menu' | asset: 'header'"
    alt="menu"
    width="24"
    height="24"
    class="cursor-pointer"
    (click)="toggleNavBlock()"
/>
@if (showNav) {
    <div
        class="tab:w-400px w-353px min-h-screen absolute top-0 left-0 z-50 bg-white transition-transform duration-300 ease-in-out transform"
        companyidClickOutside
        [companyidDisabledScroll]="showNav"
        (onClickOutside)="onClickOutside()"
    >
        <div class="gap-25px flex items-center p-30px bg-dark h-24">
            <img
                aria-hidden="true"
                [ngSrc]="'close' | asset: 'header'"
                alt="menu"
                width="24"
                height="24"
                class="cursor-pointer"
                (click)="toggleNavBlock()"
            />
            <companyid-logo logoColor="white" (click)="toggleNavBlock()" />
        </div>
        <div class="flex flex-col px-30px py-5 gap-y-5">
            @for (header of navigation(); track header.title) {
                <div class="gap-y-25px">
                    <button
                        [title]="header.title"
                        (click)="toggleNavBlock()"
                        [routerLink]="header.route"
                        class="button-ghost-gray h-6 w-full !justify-start text-dark text-medium-medium"
                    >
                        {{ header.title }}
                    </button>
                </div>
            }

            <companyid-language-switcher class="tab:hidden w-fit" />

            <hr class="border border-solid border-gray-3 w-full" />
            <companyid-social-media svgClassNames="size-9" isDark />
            <hr class="border border-solid border-gray-3 w-full" />
            <a i18n="@@button-get-demo" class="button-primary-outline w-full" routerLink="/contact-us"> Get demo </a>
        </div>
    </div>
}
